import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import EnhancedTable from './EnhancedTable';
import PaymentDetails from './PaymentDetails';
import PaymentTable from './PaymentMemoTable';
import { Typography, FormControlLabel, Checkbox } from '@material-ui/core';
import OpenModal from './OpenModal';

let moment = require('moment-timezone');

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        position: 'relative',
    },
});

const customStyles = {
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',     
      transform             : 'translate(-50%, -50%)',
      padding               : '0',
      border                : 'none',
      borderRadius          : '0',
      boxShadow             : '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.6)',
      overlfow              : 'hidden'
    }
  };

class OpenInvoices extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            time: Date.now(), 
            modalIsOpen:false,
            modalMessage:'',
            isPrepayment: false
         };

       this.openModal = this.openModal.bind(this);
       this.closeModal = this.closeModal.bind(this); 
       this.refresh = this.refresh.bind(this);
       this.handlePrepaymentChange = this.handlePrepaymentChange.bind(this);
    }

    handlePrepaymentChange = (event) => {
        this.setState({ isPrepayment: event.target.checked });
    }

      componentDidMount() {
        this.interval = setInterval(() => this.sessionHandling(), 480000);
      }
      componentWillUnmount() {
        clearInterval(this.interval);
      }
      openModal = (modalMessage) =>{     
        this.setState(
            {
            modalIsOpen: true,
            modalMessage:modalMessage
        });        
      }

      closeModal = () => {
        this.setState({modalIsOpen: false});
      }
      
      close_modal() {
        let customerAllInvoices = this.props.invoices;
        let customerAllCredits = this.props.credit;
        let selectedInvoices = customerAllInvoices.filter(invoice => invoice.selected);
        let selectedCredits = customerAllCredits.filter(creditMemo => creditMemo.selected);
        if(selectedInvoices.length > 0 || selectedCredits.length > 0){
          this.closeModal()
        }else{
           this.refresh();
        }
      }

      getParent() {       
        return document.getElementsByTagName('body')[0];       
      }

      sessionHandling(){
         let notificationMessage ='refreshHandling';
         this.openModal(notificationMessage);
      }

      refresh= () => {
        //setTimeout(function() { window.location.reload() },5000);
        this.closeModal();
        window.location.reload();
      }

    render() {
        const { classes, invoices, credit,customer } = this.props;
        let momentDate = moment.utc(customer.portalUpdateDate);
        let date = momentDate.tz('America/New_York').format("YYYY-MM-DD, HH:mm:ss A");
       return (
            <div className={classes.root}>
           <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
             <Typography align="justify" style={{ marginRight: 16 }}>As on: {date}</Typography>
             <FormControlLabel
               control={
                 <Checkbox
                   checked={this.state.isPrepayment}
                   onChange={this.handlePrepaymentChange}
                   color="primary"
                 />
               }
               label="Prepayment"
             />
           </div>
                {!this.state.isPrepayment && <EnhancedTable />}
                {!this.state.isPrepayment && <PaymentTable/>}
                <PaymentDetails isPrepayment={this.state.isPrepayment} />

            <OpenModal 
            customStyles={customStyles} modalIsOpen={this.state.modalIsOpen}
            closeModal={this.closeModal} getParent={this.getParent}
            closeOnClick={this.close_modal.bind(this)} 
            refreshOnClick = {this.refresh.bind(this)} 
            modalMessage={this.state.modalMessage}>
            </OpenModal>
            </div>
        )
    }
}

OpenInvoices.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    customer: state.auth.customer,
    invoices: state.invoice.invoices,
    credit: state.credit.credit
})

const mapDispatchToProps = dispatch => bindActionCreators({
    changePage: () => push('/payment-success')
}, dispatch)

export default connect(mapStateToProps,
    mapDispatchToProps)(withStyles(styles)(OpenInvoices));


// WEBPACK FOOTER //
// ./src/OpenInvoices.js